import React, { Component } from 'react';
import { Header, Segment, Label } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';

class CompanyInformation extends Component {
  render() {
    const fylker = [
      { text: 'Agder', value: 'Agder' },
      { text: 'Akershus', value: 'Akershus' },
      { text: 'Buskerud', value: 'Buskerud' },
      { text: 'Finnmark', value: 'Finnmark' },
      { text: 'Innlandet', value: 'Innlandet' },
      { text: 'Møre og Romsdal', value: 'Møre og Romsdal' },
      { text: 'Nordland', value: 'Nordland' },
      { text: 'Oslo', value: 'Oslo' },
      { text: 'Rogaland', value: 'Rogaland' },
      { text: 'Telemark', value: 'Telemark' },
      { text: 'Troms', value: 'Troms' },
      { text: 'Trøndelag', value: 'Trøndelag' },
      { text: 'Vestfold', value: 'Vestfold' },
      { text: 'Vestland', value: 'Vestland' },
      { text: 'Østfold', value: 'Østfold' },
    ];

    const errorLabel = <Label color="red" pointing basic />;

    return (
      <Segment>
        <Header as="h2">Bedriftsinformasjon</Header>
        <Form.Group>
          <Form.Input
            name="company"
            label="Navn på bedrift"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Bedriftsnavn er påkrevd',
            }}
            errorLabel={errorLabel}
            width={10}
          />
          <Form.Input
            name="00Nb0000004dyXp"
            label="Organisasjonsnummer"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Organisasjonsnummer er påkrevd',
            }}
            errorLabel={errorLabel}
            width={6}
          />
        </Form.Group>
        <Form.Input
          name="00Nb0000004dyOa"
          label="Eiere"
          required
          validationErrors={{
            isDefaultRequiredValue: 'Eiere er påkrevd',
          }}
          errorLabel={errorLabel}
        />
        <Form.TextArea
          name="street"
          label="Adresse"
          required
          validationErrors={{
            isDefaultRequiredValue: 'Adresse er påkrevd',
          }}
          errorLabel={errorLabel}
          rows={2}
        />
        <Form.Group widths="equal">
          <Form.Input
            name="zip"
            label="Postnummer"
            required
            validations="isNumeric"
            validationErrors={{
              isNumeric: 'Dette er ikke et gyldig postnummer',
              isDefaultRequiredValue: 'Postnummer er påkrevd',
            }}
            errorLabel={errorLabel}
          />
          <Form.Input
            name="city"
            label="Poststed"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Poststed er påkrevd',
            }}
            errorLabel={errorLabel}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Kommune"
            name="00Nb0000004dyhW"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Kommune er påkrevd',
            }}
            errorLabel={errorLabel}
          />
          <Form.Select
            name="state"
            label="Fylke"
            required
            validationErrors={{
              isDefaultRequiredValue: 'Fylke er påkrevd',
            }}
            errorLabel={errorLabel}
            placeholder="Velg fylke"
            options={fylker}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input name="00Nb0000004dyOV" label="Bruksnummer" />
          <Form.Input name="00Nb0000004dyB5" label="Gårdsnummer" />
          <Form.Input name="00Nb0000004dyOf" label="Eventuelt festenummer" />
        </Form.Group>
      </Segment>
    );
  }
}

export default CompanyInformation;



// WEBPACK FOOTER //
// ./src/Form/CompanyInformation.js